
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-select",
      function () {
        return require("private-next-pages/joy-ui/react-select.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-select"])
      });
    }
  